import { CheckmarkGreen } from '@core/assets/CheckmarkGreen';
import { CloseX40x40 } from '@core/assets/CloseX40x40';
import { useContextTranslation } from '@core/i18n';
import { AddToCartButtonWrapper, AddToCartInnerButton, } from './AddToCartButton.styles';
/**
 *
 */
export function AddToCartButton({ status, onAddClick, addButtonDisabled, productName, }) {
    const { t } = useContextTranslation();
    return (<AddToCartButtonWrapper aria-live="polite">
      {status !== undefined ? (status ? (<CheckmarkGreen label={t('player:Product added to cart')} height={32} width={32}/>) : (<CloseX40x40 label={t('player:Error adding product to cart')} height={32} width={32} color="var(--red)"/>)) : (<AddToCartInnerButton onClick={onAddClick} disabled={addButtonDisabled} aria-label={t('player:Add {{productName}} to cart', { productName })}>
          <span>+</span>
        </AddToCartInnerButton>)}
    </AddToCartButtonWrapper>);
}
